import { cx } from "@emotion/css";
import ErrorIcon from "@mui/icons-material/Error";
import useDeviceType from "hooks/useDeviceType";
import FlatBoxLayout from "library/Layouts/BoxLayout/FlatBoxLayout";
import PropTypes from "prop-types";
import styles from "./styles";

const MessageLayout = ({ className, contentClassName, labelSection, color, ...restProps }) => {
  const { isMobile } = useDeviceType();

  return (
    <FlatBoxLayout
      className={cx(className, "align-items-center text-color-white", isMobile && "col-12 px-0")}
      color={color}
      {...restProps}
    >
      <ErrorIcon className={cx(styles.icon, "mr-2")} />
      <span className={cx(contentClassName, "text-fw-semibold")}>{labelSection}</span>
    </FlatBoxLayout>
  );
};

MessageLayout.defaultProps = {
  className: "",
  contentClassName: "",
  labelSection: null,
  color: "primary",
};

MessageLayout.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  labelSection: PropTypes.node,
  color: PropTypes.oneOf(["primary", "warning", "error", undefined]),
};

export default MessageLayout;
